import { PartialsEvents } from 'assets/core/js/module/partialsManager'
import accommodationCards from 'assets/themes/campings/js/page/product/accommodationCards'

export default (): void => {
  handleShowMoreAccommodations()
  handlePartialUpdate()
}

export function toggleAccommodations(target: string): void {
  const additionalAccommodationsList = document.querySelector(`.results__list[data-additional-accommodations="${target}"]`)
  additionalAccommodationsList?.toggleAttribute('hidden')

  const buttonEl = document.querySelector<HTMLButtonElement>(`button[data-additional-accommodations="${target}"]`)

  if (!buttonEl) {
    return
  }

  buttonEl.querySelectorAll('span').forEach((link) => {
    link.toggleAttribute('hidden')
  })
}

function handleShowMoreAccommodations(): void {
  const showAdditionalAccommodations = document.querySelectorAll<HTMLButtonElement>('.results__button-additional-accommodations')

  showAdditionalAccommodations.forEach((showAdditionalAccommodations) => {
    showAdditionalAccommodations.addEventListener('click', (e) => {
      const el = e.target as HTMLElement
      const target = el.getAttribute('data-additional-accommodations')

      target && toggleAccommodations(target)
    })
  })
}

function handlePartialUpdate(): void {
  const resultsEl = document.querySelector('.product__results')

  if (!resultsEl) {
    return
  }

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        accommodationCards()

        observer.unobserve(entry.target)
      }
    })
  })

  observer.observe(resultsEl)

  resultsEl.addEventListener(PartialsEvents.POST_UPDATE, () => {
    // remove all sidepanels as they exists outside of the results element
    document.querySelectorAll('.accommodation__side-panel').forEach((el) => {
      el.remove()
    })
    handleShowMoreAccommodations()
  })
}
